function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashlightOff = function SvgFlashlightOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 5.33337L2.72897 8.45861C2.49643 8.73766 2.38016 8.87718 2.37839 8.99502C2.37684 9.09745 2.42249 9.19491 2.50217 9.2593C2.59383 9.33337 2.77545 9.33337 3.13869 9.33337H8L7.33333 14.6667L10.6667 10.6667M10.4334 6.66671H12.8613C13.2245 6.66671 13.4062 6.66671 13.4978 6.74078C13.5775 6.80517 13.6232 6.90263 13.6216 7.00507C13.6198 7.1229 13.5036 7.26243 13.271 7.54147L12.3668 8.62651M7.0485 3.27514L8.66664 1.33337L8.26683 4.53185M14 14L2 2.00004",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgFlashlightOff;